import React from "react";
import { cn } from "../../lib/utils";

export const BentoGrid = ({ className, children }) => {
  const items = React.Children.toArray(children);
  return (
    <div
      className={cn(
        "mx-auto grid max-w-7xl px-8 gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 auto-rows-[300px]",
        className
      )}
    >
      {items.map((child, i) => (
        <div
          key={i}
          className={cn(
            "h-full",
            // Feature key items responsively for a balanced mosaic
            i === 0 && "sm:col-span-2 lg:col-span-2 xl:col-span-2",
            i === 5 && "lg:col-span-2 xl:col-span-2",
            // Feature the second-to-last card on xl (last row, middle spotlight)
            i === items.length - 2 && "xl:col-span-2"
          )}
        >
          {child}
        </div>
      ))}
    </div>
  );
};

export const BentoGridItem = ({
  className,
  title,
  description,
  header,
  icon
}) => {
  return (
    <div
      className={cn(
        "group/bento row-span-1 overflow-hidden rounded-xl border border-white/[0.2] transition-all duration-300",
        className
      )}>
      <div className="relative w-full h-full">
        {/* Background Image */}
        {header}
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-black/80 opacity-90 transition-opacity duration-300 group-hover/bento:opacity-70" />
        
        {/* Content Container */}
        <div className="absolute inset-x-0 bottom-0 p-6 transition-transform duration-300">
          <div className="space-y-3">
            <h3 className="font-bold text-xl text-white group-hover/bento:text-white/90">
              {title}
            </h3>
            <p className="text-sm text-white/80 group-hover/bento:text-white/70">
              {description}
            </p>
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
};
